// extracted by mini-css-extract-plugin
export default {"root":"root-s7YStY","value":"value-FwiWcL","label":"label-mTqv69"};